import { Capacitor } from '@capacitor/core';
import { APP_PUBLIC_URL } from './config';

export const OAUTH_CALLBACK_PATH = '/auth/callback';
export const OAUTH_NATIVE_SCHEME = 'com.foundersbridge.app';

export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

/** Web: canonical APP_PUBLIC_URL (not Azure *.azurewebsites.net). Native: custom URL scheme. */
export function getOAuthRedirectUrl() {
  if (isNativeApp()) {
    return `${OAUTH_NATIVE_SCHEME}://auth/callback`;
  }
  if (typeof window !== 'undefined') {
    const origin = window.location.origin || '';
    if (/localhost|127\.0\.0\.1/i.test(origin)) {
      return `${origin}${OAUTH_CALLBACK_PATH}`;
    }
  }
  return `${APP_PUBLIC_URL}${OAUTH_CALLBACK_PATH}`;
}

export function isOAuthCallbackUrl(urlOrPath = '') {
  const s = String(urlOrPath);
  if (s.includes('/auth/callback') || s.includes(`${OAUTH_NATIVE_SCHEME}://auth/callback`)) return true;
  if (s.includes('access_token=')) return true;
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : APP_PUBLIC_URL;
    const u = new URL(s, base);
    if (u.searchParams.get('code')) return true;
    if (u.hash && new URLSearchParams(u.hash.replace(/^#/, '')).get('code')) return true;
  } catch (_) { /* ignore */ }
  return false;
}
